"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentBox = exports.CONTENT_BOX_MAX_WIDTH = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_1 = __importDefault(require("@emotion/styled"));
const Box_1 = require("./Box");
const constants_1 = require("../constants");
const utils_1 = require("../utils");
const colors = {
    'dark-blue': {
        accentColor: constants_1.Color.BLUE,
        backgroundColor: constants_1.Color.BLUE,
        border: undefined,
        color: constants_1.Color.WHITE,
    },
    'light-grey': {
        accentColor: constants_1.Color.BLUE,
        backgroundColor: constants_1.Color.LIGHT_GREY,
        border: constants_1.theme.border.style.thin,
        color: undefined,
    },
    red: {
        accentColor: constants_1.Color.LIGHT_RED,
        backgroundColor: constants_1.Color.LIGHTER_RED,
        border: `1px solid ${constants_1.Color.MEDIUM_RED}`,
        color: undefined,
    },
    white: {
        accentColor: constants_1.Color.BLUE,
        backgroundColor: constants_1.Color.WHITE,
        border: constants_1.theme.border.style.thin,
        color: undefined,
    },
};
const ContentBoxElement = styled_1.default.div((props) => {
    const { accentColor, backgroundColor, border, color } = props.color
        ? colors[props.color]
        : colors.white;
    const accentBorder = `${constants_1.theme.border.radius.normal}px solid ${accentColor}`;
    return {
        border,
        borderBottom: props.highlightBorder === 'bottom' ? accentBorder : undefined,
        borderLeft: props.highlightBorder === 'left' ? accentBorder : undefined,
        borderRadius: constants_1.theme.border.radius.normal,
        width: props.fullWidth ? '100%' : undefined,
        ...(0, Box_1.box)(props),
        boxShadow: constants_1.theme.boxShadow.normal,
        color,
        maxWidth: props.clamped ? exports.CONTENT_BOX_MAX_WIDTH : undefined,
        padding: props.spacing === 'compact'
            ? 12
            : props.spacing === 'semi-compact'
                ? 18
                : 24,
        backgroundColor,
        boxSizing: 'border-box',
        [(0, utils_1.mediaBreakpointGte)('md')]: {
            padding: props.spacing === 'compact'
                ? 16
                : props.spacing === 'semi-compact'
                    ? 24
                    : 32,
        },
    };
});
exports.CONTENT_BOX_MAX_WIDTH = 640;
const ContentBox = (props) => {
    const { children, ...boxProps } = props;
    return (0, jsx_runtime_1.jsx)(ContentBoxElement, { ...boxProps, children: children });
};
exports.ContentBox = ContentBox;
